module.exports = __webpack_public_path__ + "31d6cfe0d16ae931b73c59d7e0c089c0.svg";